// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NWI3","left":"styles_left__3CTgH"};